import { inject, Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'safeHtml',
})
export class SafeHtmlPipe implements PipeTransform {
  private readonly _saniziter = inject(DomSanitizer);

  transform(value: string) {
    if (!value) {
      return null;
    }

    return this._saniziter.sanitize(SecurityContext.HTML, value);
  }
}
